import React, { useState, useEffect } from 'react'
import { PostData } from '../Services/httpHandelars';
import { useLocation } from 'react-router-dom';
import Snackbar from '../Components/Snackbar';




export default function ResetPassword() {

    const [form, setform] = useState({newpassword:"", confirmpassword:""});
    const [snacBar, setSnacBar ] =useState({snacStatus: false, message:"", snackType:""})

    const handleChange = (e) =>{
        setform({...form, [e.target.name]:e.target.value})
    }


  const withToken = useLocation().search;   
  const token=new URLSearchParams(withToken).get("token");


  const validatePassword = (pass) => {
    const reg = /(?=^.{8,16}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)[0-9a-zA-Z!*^?](?=.*[+-_@#$%&])/
    return reg.test(pass)
}

    const handleSubmit = () =>{

        if(form.newpassword && form.confirmpassword && token){
          if (form.newpassword.length >= 8 && form.confirmpassword.length >= 8) {
            if (validatePassword(form.newpassword) && validatePassword(form.confirmpassword)) {
              if (form.newpassword === form.confirmpassword) {

          PostData("/api/ResetPassword", {...form, token}).then((Success)=>{
            if(Success.status){

              setSnacBar({...snacBar, 
                snacStatus: true,
                message: Success.message,
                snackType:"Success"
              })
            }else{
              setSnacBar({...snacBar, 
                snacStatus: true,
                message: Success.message,
                snackType:"Error"
              })
            }
          })
        }else {
          setSnacBar({
              ...snacBar,
              snacStatus: true,
              message: "Password does not match",
              snackType: "warning"
          })
      }
        }else{
          setSnacBar({...snacBar, 
            snacStatus: true,
            message: "Add special character and capital letter and number",
            snackType:"warning"
          })
        }
        }else{
          setSnacBar({...snacBar, 
            snacStatus: true,
            message: "Password length must be 8",
            snackType:"warning"
          })
        }


        }else{
          setSnacBar({...snacBar, 
            snacStatus: true,
            message: "Please Enter Password",
            snackType:"warning"
          })
          
        }

    }


    useEffect(
      () => {
          if (snacBar.snacStatus === true) {
              setTimeout(() => setSnacBar(false), 3000);
          }
      },
  
      [snacBar.snacStatus]
  );

  return (
    <>
    <div className="flex justify-center mt-28">
    <div className="block p-6 rounded-lg shadow-lg bg-white w-1/5">
      <h5 className="text-gray-900 text-xl leading-tight font-medium mb-2 text-center">Change Password</h5>
     
      <div className="mb-4 mt-8">
        <label className="block text-gray-700 text-sm font-bold mb-2" for="username">
          New Password
        </label>
        <input
          onChange={handleChange} 
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
          id="newpassword" 
          type="password" 
          name="newpassword"
          value={form.newpassword}
        />
      </div>

      <div className="mb-4 mt-8">
        <label className="block text-gray-700 text-sm font-bold mb-2" for="username">
          Confirm Password
        </label>
        <input
          onChange={handleChange} 
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
          id="confirmpassword" 
          type="password" 
          name="confirmpassword"
          value={form.confirmpassword}
        />
      </div>

      <div>
        <button
          onClick={handleSubmit} 
          type="button" 
          className="inline-block w-full py-2.5 bg-green-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out">Change Password</button>
      </div>

    </div>
  </div>
   {snacBar?.snacStatus &&
    <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar}/>
}
</>
  )
}
